import { getPresignedURLForPut, fileUploadToS3, IFile, uploadCvForSubmissions } from 'wisestep-api';
import * as yup from 'yup';

import { success, failed } from '../../../utils/NotificationMessages';
import { getFile } from '../../careerPageSettings/util';
import { IExcelRecords } from '../types';

export const createRowsForSubmissions = (candidatesData: Map<number, IExcelRecords>) => {
  const rows: IExcelRecords[] = [];
  for (let i = 0; i < 99 && candidatesData[i]; i++) {
    const row = candidatesData[i];
    rows.push(row);
  }
  return rows;
};

export const onCVViewClick = async (url: string): Promise<string> =>
  await getFile(url.split('?')[0]);

export const downloadBulkSubmissionsSampleFile = () =>
  window.open('https://wisestep-open.s3.eu-west-1.amazonaws.com/bulkSubmissionsSampleFormat.xlsx');

export const uploadFileToS3 = async (file: File[], setNotification): Promise<IFile> => {
  try {
    const response = await getPresignedURLForPut({
      fileName: file[0].name,
      fileType: file[0].type,
    });
    await fileUploadToS3(file[0], response.data.preSignedUrl);
    setNotification(success('Uploaded file(s) successfully!'));
    return { location: response.data.preSignedUrl, name: file[0].name };
  } catch {
    setNotification(failed('Failed to upload file'));
  }
  return { name: '', location: '' };
};

export const saveUploadedCV = async (
  file: IFile,
  index: number,
  fileId: string,
  setNotification
): Promise<number> => {
  try {
    if (fileId && index > -1) {
      file.location = file.location.split('?')[0];
      await uploadCvForSubmissions(index, fileId, file);
      setNotification(success('CV uploaded successfully !!'));
      return 1;
    } else {
      setNotification(failed('Few details are missing to upload CV, Please try again !!'));
      return 0;
    }
  } catch {
    setNotification(failed('Error in CV upload , Please try again !!'));
    return 0;
  }
};

export const bulkMappingsUploadSchema = yup.object().shape({
  locations: yup.object().nullable(true).required('Please Select a Country'),
  fieldMappings: yup
    .array()
    .default([])
    .min(1, 'please select column mapping for email')
    .test('email', 'please select column mapping for email', (value) => {
      const filteredArray = value?.filter((e) => e === 'email');
      if (filteredArray?.length < 1) return false;
      return true;
    })
    .required('please select column mapping for email'),
});

export const bulkSubmissionsUploadSchema = yup.object().shape({
  locations: yup.object().nullable(true).required('Please Select a Country'),
});
